<template>
<div>
  <div class="screen-message">
    <div class="message-item text-center">
      <h1>
        <span>구인사이트로 이동</span>
      </h1>
      <p>조금만 기다려주세요.</p>
      <p>화면이 바뀌지 않으면 아래 버튼을 클릭해 주세요.</p>
      <div class="back-button">
        <button type="button" class="el-button el-button--success" id="send-mynabi-pdf" 
        style="background-color: #E3165C; border-color: #E3165C; font-size: 120%; margin: 15px 0px 0px;"
         @click="goJobdetail()"><!----><!----><span>공고 상세확인</span></button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  methods: {
    goJobdetail: function () {
      const formData = new FormData()
      formData.append('uuid', this.$route.query.uuid)
      formData.append('format_id', this.$route.query.formatid)
      formData.append('keyword', this.$route.query.keyword)
      formData.append('jt', this.$route.query.jt)
      formData.append('area', this.$route.query.area)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'm')
      formData.append('app_flag', this.$site.appFlag)

      const app = this
      this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, {timeout: 60000})
      location.href=this.redirectURL
    }
  },
  created: function() {
    this.redirectURL = this.$route.query.joburl
    const formData = new FormData()
    formData.append('uuid', this.$route.query.uuid)
    formData.append('format_id', this.$route.query.formatid)
    formData.append('keyword', this.$route.query.keyword)
    formData.append('jt', this.$route.query.jt)
    formData.append('area', this.$route.query.area)
    formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
    formData.append('version', '2')
    formData.append('site_flag', 'm')
    formData.append('app_flag', this.$site.appFlag)

    const app = this
    this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, {timeout: 60000})
    location.href=this.redirectURL
  }
}
</script>
